module.exports = __webpack_public_path__ + "img/logo-invoize-no-edas.294c07bb.png";